import {
  HttpRequest,
  HttpEvent,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { inject } from '@angular/core';
import { environment } from '../../../../environments/environment';

export const jwtInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const authenticationService = inject(AuthenticationService); // Using inject() for DI
  const isLoginRequest = req.url.includes('/login');
  if (isLoginRequest) {
    return next(req); // Skip token addition for login requests
  }
  const currentUser = authenticationService?.currentUserValue.user_profile;
  const token = currentUser?.access_token;
  const isAdrApiUrl = req.url.startsWith(environment.apiUrl);
  const isDispatchApiUrl = req.url.startsWith(environment.dispatchUrl);
  if (token && isAdrApiUrl) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${currentUser.access_token}`,
      },
    });
  } else if (isDispatchApiUrl) {
    const apiKey = authenticationService.getDispatchApiKey();
    req = req.clone({
      setHeaders: { ApiKey: encodeURIComponent(apiKey) },
    });
  }

  return next(req); // HttpHandlerFn expects next(req), not next.handle(req)
};
